import { Select as MuiSelect, styled, css } from '@mui/material'
import { merge } from 'maeng-utils/utils'
import { SelectProps } from './Select.types'

export const Select = styled(
  ({ className, MenuProps, ...props }: Omit<SelectProps<any>, 'helperText'>) => {
    const menuProps = merge(MenuProps, { classes: { root: className } })
    return <MuiSelect {...props} className={className} MenuProps={menuProps} />
  },
  {
    shouldForwardProp: (prop: string) => prop !== 'maxHeight',
  },
)`
  min-height: 32px;
  margin-bottom: 7px;
  ${({ theme }) => ({ ...theme.typography.subheading })}

  ${({ maxHeight }) =>
    maxHeight &&
    css`
      max-height: ${maxHeight}px;
    `}

  &.Mui-error {
    .MuiSelect-select {
      color: ${({ theme }) => theme.palette.error.main};
    }

    .MuiSelect-icon {
      ${({ error, theme }) =>
        error &&
        css`
          color: ${theme.palette.error.main};
        `}
    }
  }

  :hover:not(.Mui-disabled)::before {
    border-bottom-width: 1px;
  }

  .MuiInput-input.MuiSelect-select {
    min-height: 23px;
    font-weight: 400;
  }

  .MuiMenuItem-root {
    min-height: 48px;
    font-weight: 400;
  }
`

export const Placeholder = styled(`span`)<{ label: unknown }>`
  position: absolute;
  top: ${({ label }) => (label ? 20 : 5)}px;
  left: 0;
  color: rgba(0, 0, 0, 40%);
  pointer-events: none;
`
